var _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleMetric({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 125,
    viewBox: "0 0 235 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_63)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 125,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 125,
    rx: 2,
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_752_63",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 125,
    rx: 2,
    fill: "transparent"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_752_63)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 67,
    rx: 4,
    fill: "#5879AD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 69,
    width: 120,
    height: 56,
    rx: 4,
    fill: "#5879AD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 69,
    width: 113,
    height: 56,
    rx: 4,
    fill: "#5879AD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 219,
    height: 10,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 77,
    width: 104,
    height: 10,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 77,
    width: 97,
    height: 10,
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 97,
    width: 53,
    height: 19,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 97,
    width: 53,
    height: 19,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 26,
    width: 107,
    height: 33,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 125,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleMetric);
export default __webpack_public_path__ + "static/media/multiple-metric.7e11a1b7d68accd8dd09b79299ab996f.svg";
export { ForwardRef as ReactComponent };